import { render, staticRenderFns } from "./WebHostingWebsiteAliases.vue?vue&type=template&id=28cb6751&scoped=true&"
import script from "./WebHostingWebsiteAliases.vue?vue&type=script&lang=js&"
export * from "./WebHostingWebsiteAliases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cb6751",
  null
  
)

export default component.exports